/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OdbCriteriaNote } from './OdbCriteriaNote';
import {
    OdbCriteriaNoteFromJSON,
    OdbCriteriaNoteFromJSONTyped,
    OdbCriteriaNoteToJSON,
} from './OdbCriteriaNote';

/**
 * 
 * @export
 * @interface OdbLimitedUseCriteria
 */
export interface OdbLimitedUseCriteria {
    /**
     * Limited Coverage Code ID
     * @type {string}
     * @memberof OdbLimitedUseCriteria
     */
    lcc_id: string;
    /**
     * 
     * @type {string}
     * @memberof OdbLimitedUseCriteria
     */
    generic_name?: string;
    /**
     * 
     * @type {string}
     * @memberof OdbLimitedUseCriteria
     */
    authorization_period?: string;
    /**
     * 
     * @type {Array<OdbCriteriaNote>}
     * @memberof OdbLimitedUseCriteria
     */
    criteria_notes?: Array<OdbCriteriaNote>;
    /**
     * 
     * @type {number}
     * @memberof OdbLimitedUseCriteria
     */
    last_updated?: number;
}

/**
 * Check if a given object implements the OdbLimitedUseCriteria interface.
 */
export function instanceOfOdbLimitedUseCriteria(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "lcc_id" in value;

    return isInstance;
}

export function OdbLimitedUseCriteriaFromJSON(json: any): OdbLimitedUseCriteria {
    return OdbLimitedUseCriteriaFromJSONTyped(json, false);
}

export function OdbLimitedUseCriteriaFromJSONTyped(json: any, ignoreDiscriminator: boolean): OdbLimitedUseCriteria {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lcc_id': json['lcc_id'],
        'generic_name': !exists(json, 'generic_name') ? undefined : json['generic_name'],
        'authorization_period': !exists(json, 'authorization_period') ? undefined : json['authorization_period'],
        'criteria_notes': !exists(json, 'criteria_notes') ? undefined : ((json['criteria_notes'] as Array<any>).map(OdbCriteriaNoteFromJSON)),
        'last_updated': !exists(json, 'last_updated') ? undefined : json['last_updated'],
    };
}

export function OdbLimitedUseCriteriaToJSON(value?: OdbLimitedUseCriteria | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'lcc_id': value.lcc_id,
        'generic_name': value.generic_name,
        'authorization_period': value.authorization_period,
        'criteria_notes': value.criteria_notes === undefined ? undefined : ((value.criteria_notes as Array<any>).map(OdbCriteriaNoteToJSON)),
        'last_updated': value.last_updated,
    };
}

